import {
  IonAvatar,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonPage,
  IonSpinner,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import { chevronBack } from "ionicons/icons";
import { useState } from "react";
import { useHistory } from "react-router";
import { BasicStrategy } from "../components/BasicStrategy";
import { useUsersStore } from "../stores/users.store";
import { useBotsStore } from "../stores/bots.store";
import { useQuestsStore } from "../stores/quests.store";
import axios from "axios";
import toast from "react-hot-toast";
import { getFirstIncompleteStage } from "../utils/levelUtils";
import { useInterval } from "../hooks/useInterval";
import { useParams } from "react-router-dom";

const loadingBlurbs = [
  "Fetching trading records...",
  "Bot boot sequence initiated...",
  "Setting bot strategy...",
  "Fastening seatbelts...",
  "Finalising trade preparations..."
];

const QuoQuestLevelBot = () => {
  const { levelId, stageIndex } = useParams<{
    levelId: string;
    stageIndex: string;
  }>();

  const history = useHistory();
  const profile = useUsersStore(state => state.user);
  const [userBot, levels, questId] = useQuestsStore(state => [
    state.bot,
    state.levels,
    state.id
  ]);
  const setBot = useBotsStore(state => state.addOrUpdateBot);

  const [blurbIndex, setBlurbIndex] = useState(0);
  const [currentLoadingBlurb, setCurrentLoadingBlurb] = useState(
    loadingBlurbs[blurbIndex]
  );
  const [isCreatingStageRun, setIsCreatingStageRun] = useState(false);

  // Set fun loading blurbs
  useInterval(
    () => {
      if (blurbIndex !== loadingBlurbs.length - 1) {
        setCurrentLoadingBlurb(loadingBlurbs[blurbIndex + 1]);
        setBlurbIndex(blurbIndex + 1);
      }
    },
    isCreatingStageRun ? 1700 : null
  );

  const runLevel = async () => {
    userBot.user = profile?.userId;
    const data = {
      bot: userBot,
      stage: getFirstIncompleteStage(levels),
      questId
    };
    setIsCreatingStageRun(true);
    axios
      .post(
        // "http://127.0.0.1:5001/quidpro-903c6/us-central1/createQuestStageRun",
        "https://us-central1-quidpro-903c6.cloudfunctions.net/runStage",
        data
      )
      .then(response => {
        // Route to game page with lobbyId
        history.push(
          `/quest/levels/${levelId}/${stageIndex}/game/${response.data.lobbyId}`
        );
        // history.push(`/challenge/${response.data.lobbyId}`);
        setIsCreatingStageRun(false);
      })
      .catch(error => {
        toast.error("Error starting stage");
        setIsCreatingStageRun(false);
        console.error(error);
      });
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon className="text-white" icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle className="capitalize font-normal pt-4">
            Set Strategy
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className="flex flex-col h-full">
          <div className="grow">
            <div className="flex items-center">
              <IonAvatar className="w-[4.5rem] h-[4.5rem] border-white border m-4 bg-slate-300">
                {userBot?.img && <IonImg src={userBot?.img} alt="bot avatar" />}
              </IonAvatar>
              <div className="text-white text-sm flex flex-col">
                <span className="text-xl font-bold">{userBot?.name}</span>
                <span className="flex items-center gap-1">
                  <div className="rounded-full bg-success w-1.5 h-1.5"></div>@
                  {profile?.username}
                </span>
              </div>
            </div>
            <BasicStrategy bot={userBot} setBot={setBot} />
          </div>
          <div className="mb-24">
            <div className="ion-text-center py-2 px-4">
              <IonButton
                color="primary"
                className="h-16 text-base"
                expand="block"
                onClick={() => runLevel()}
                disabled={isCreatingStageRun}
              >
                {isCreatingStageRun ? (
                  <>
                    <IonSpinner name="crescent"></IonSpinner>
                    <span className="ml-2">{currentLoadingBlurb}</span>
                  </>
                ) : (
                  "Let's Trade"
                )}
              </IonButton>
            </div>
            <div className="ion-text-center py-2 px-4">
              <IonButton
                fill="outline"
                className="text-white h-16 text-base"
                expand="block"
                onClick={() => history.goBack()}
              >
                Cancel
              </IonButton>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};
export default QuoQuestLevelBot;
